import script from "./EinladungIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./EinladungIndex.vue?vue&type=script&setup=true&lang=js"

import "./EinladungIndex.vue?vue&type=style&index=0&id=27a72092&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a72092"]])

export default __exports__